import React from 'react';
import { Link } from 'react-router-dom';
import './Home.css';

const Home: React.FC = () => {
  return (
    <div className="home-page-layout">
      <div className="main-content">
        <div className="hero-section">
          <img src="/hero.jpg" alt="Jack and Dyl Experiences" className="hero-image" />
          <div className="hero-title">
            <h1>Jack and Dyl</h1>
            <h1>Experiences</h1>
          </div>
        </div>
        <div className="intro-paragraph">
          <p>Jackie and Dylan are excited to bring a unique blend of experiences to Brooklyn, NY. With a focus on creativity and community, they offer a diverse array of services, from crafting custom goods tailored to individual tastes, to hosting intimate supper clubs that celebrate culinary artistry and foster meaningful connections. Their offerings are designed to provide a personal touch in every interaction, ensuring each experience is memorable and distinctive. Jackie and Dylan aim to enrich your life with creativity and warmth in the heart of Brooklyn.</p>
        </div>
      </div>
    </div>
  )};
export default Home;